module.exports = __webpack_public_path__ + "static/wolfgang-ole-5283d761d348b3bf243313d87bf4163e.jpg";